import {gql, useQuery} from '@apollo/client';

export const useIdentity = () => {
  const {data, loading, error} = useQuery(IdentityQuery);
  const me = data && data.me;
  const catererAccount = me && me.catererAccount;

  return {
    me,
    catererAccount,
    loading,
    error,
  };
};

export const IdentityQuery = gql`
  query IdentityQuery {
    me {
      id
      trackingId
      catererAccount {
        id
        name
        brands {
          id
        }
      }
    }
  }
`;
